import type { JSX } from 'react'

export const EyeCrossedIcon = (): JSX.Element => (
  <use href='#eyeCrossedIcon' height='100%' width='100%' />
)
